import React, { useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, IconButton, Typography, Dialog } from "@material-ui/core";
import Delete from "@material-ui/icons/Delete";
import {
  AssetPopupClose,
  FolderIcon,
  UploadIcon,
} from "../../../ofishadmin/views/LeftNav/SvgIcons";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete, {
  createFilterOptions,
} from "@material-ui/lab/Autocomplete";
import { FiChevronDown } from "react-icons/fi";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { assetsActions } from "../../../store/assetsManagement/assetsActions";

const filter = createFilterOptions();

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#FFFFFF",
    boxShadow: "0px 0px 6px 0px #00000040",
    width: "400px",
    borderRadius: "20px !important",
  },
  papers: {
    "&.MuiAutocomplete-paper": {
      overflow: "unset",
      margin: "unset",
    },
    "& .MuiAutocomplete-listbox": {
      border: "1px solid #E1E3EA",
      borderBottomLeftRadius: "20px",
      borderBottomRightRadius: "20px",
      maxHeight: "200px !important",
      "&::-webkit-scrollbar": {
        display: "none",
      },
      padding: 0,
    },
    "& .MuiAutocomplete-option": {
      '&[data-focus="true"]': {
        backgroundColor: "#F3F6F9",
      },
      "&:nth-last-child(2)": {
        marginBottom: 30,
      },
      background: "#fff",
      "&:has(div.viewFile)": {
        color: "#3699FF",
        fontSize: 12,
        fontWeight: "500",
        position: "fixed",
        width: "328px",
        zIndex: 111,
        bottom: 1,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
      },
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "2px solid #E2E5E9",
    paddingRight: 32,
    paddingLeft: 32,
    paddingTop: 16,
    paddingBottom: 16,
    background: "#00A3FF",
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
  },
  newPricingTypo: {
    fontSize: "18px",
    fontFamily: "Roboto",
    fontWeight: 800,
    color: "#fff",
  },
  inenerContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  closIcon: {
    padding: "unset",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  fileInput: {
    display: "none",
  },
  submitBtnContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    paddingTop: "22px",
    paddingBottom: "16px",
  },
  uploadeAssetSubmitButton: {
    padding: "10px 16px",
    textAlign: "center",
    borderRadius: "6px",
    background: "#3699FF",
    width: "78px",
    height: "36px",
  },
  deleteIcon: {
    "&.MuiIconButton-root": {
      padding: 0,
    },
  },
  dialog: {
    "&.MuiDialog-paper": {
      borderRadius: "20px",
    },
  },
}));

const MediaUploadPopup = ({
  openPopup,
  closePopup,
  startLoading,
  endLoading,
  loadData,
  parent,
  onParentId,
  setView,
  setOpenGridViewOnUploadeAsset,
  setIsMoveClicked,
  selectedFolder,
  setSelectedFolder,
  setOpenAssetActionUndo,
  setFolderData,
  selectedTab,
}) => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [inputValue, setInputValue] = useState("");

  const { parentId, mediaAssetsFolder, uploadeAssetMedia, replaceAsset } =
    useSelector(state => state.AssetsReducer);

  const currentRoot = useMemo(
    () => (history ? history.location.pathname : null),
    [history],
  );

  const handleUploadSuccess = () => {
    setOpenAssetActionUndo("upload");

    if (parentId === null || parentId === 0) {
      loadData();
    }

    if (selectedTab === 5) {
      history.push("assets-media-document");
    } else {
      history.push("assets-media-library");
    }

    setOpenGridViewOnUploadeAsset("");
    setSelectedFolder("");

    setTimeout(() => {
      setOpenAssetActionUndo("");
    }, 3000);

    closePopup();
  };

  const handleSmallFileUpload = (file, assetParentId, assetType, assetId) => {
    startLoading();
    dispatch(
      assetsActions.uploadImage([file], assetParentId, assetType, assetId),
    )
      .then(data => {
        dispatch(assetsActions.onChange("uploadeAssetMedia", []));
        endLoading();
        handleClose();
        if (data[0]?.data?.success) {
          handleUploadSuccess();
        } else {
          toast.error(data?.data?.message || "Upload failed");
        }
      })
      .catch(() => {
        toast.error("Something went wrong");
        endLoading();
      });
  };

  const handleLargeFileUpload = (file, assetParentId, assetType, assetId) => {
    const abortController = new AbortController();

    dispatch(assetsActions.setAbortController(abortController));
    // Set upload started in Redux
    dispatch(
      assetsActions.setUploadProgress({
        isUploading: true,
        progress: 0,
        fileName: file.name,
        fileId: `${Date.now()}_${file.name}`,
      }),
    );

    // Close popup immediately
    closePopup();
    dispatch(
      assetsActions.largeUploadImage(
        file,
        assetParentId,
        assetType,
        assetId,
        progress => {
          // Update progress in Redux
          dispatch(
            assetsActions.setUploadProgress({
              isUploading: true,
              progress,
              fileName: file.name,
            }),
          );
        },
        abortController.signal,
      ),
    )
      .then(response => {
        if (response?.success || response?.data?.success) {
          // if (parentId === null || parentId === 0) {
          handleClose();
          loadData();

          // if (selectedTab === 5) {
          //   history.push("assets-media-document");
          // } else {
          //   history.push("assets-media-library");
          // }

          toast.success(`"${file.name}" successfully uploaded!`);
        } else {
          toast.error(
            response?.error || response?.data?.message || "Upload failed",
          );
        }

        // Reset progress after 2 seconds
        setTimeout(() => {
          dispatch(assetsActions.resetUploadProgress());
        }, 2000);
      })
      .catch(() => {
        toast.error("Something went wrong");
        dispatch(assetsActions.resetUploadProgress());
      });
  };

  const moveFilesIntoSelectedFolder = e => {
    e.preventDefault();

    if (!uploadeAssetMedia?.length) {
      toast.error("Please choose any Folder first");
      return;
    }

    const file = uploadeAssetMedia[0];
    const fileSizeInMB = file.size / (1024 * 1024);
    const assetParentId = parentId !== null ? parentId : 0;
    const assetType = selectedTab === 5 ? 2 : 1;
    const assetId = replaceAsset ? replaceAsset.id : 0;

    if (fileSizeInMB <= 25) {
      handleSmallFileUpload(file, assetParentId, assetType, assetId);
    } else {
      handleLargeFileUpload(file, assetParentId, assetType, assetId);
    }
  };

  const selectFolderDestination = () => {
    setOpenGridViewOnUploadeAsset("openGridViewOnUploadeAsset");
    setView("grid");
    setIsMoveClicked(true);
    closePopup();
  };
  const uploadFileHandle = e => {
    const selectedFile = e.target.files;

    // Sirf pehli file lo
    const file = selectedFile[0];

    // Direct ek file set karo (multiple nahi)
    dispatch(assetsActions.onChange("uploadeAssetMedia", [file]));
  };
  // const uploadFileHandle = e => {
  //   const selectedFile = e.target.files;

  //   const imageList = Object.keys(selectedFile).map(k => selectedFile[k]);

  //   const mergedArray = [...(uploadeAssetMedia || []), ...imageList].reduce(
  //     (unique, current) => {
  //       const isDuplicate = unique.some(
  //         item => item.type === current.type && item.name === current.name,
  //       );
  //       if (!isDuplicate) unique.push(current);
  //       return unique;
  //     },
  //     [],
  //   );

  //   dispatch(assetsActions.onChange("uploadeAssetMedia", mergedArray));
  // };

  const reciptSelectedFolder = [...(mediaAssetsFolder || [])];

  if (
    selectedFolder &&
    !reciptSelectedFolder.some(f => f?.id === selectedFolder?.id)
  ) {
    reciptSelectedFolder.push(selectedFolder);
  }

  reciptSelectedFolder.push({ name: "View All" });

  const handleDeleteFile = assetName => {
    if (uploadeAssetMedia?.length > 0) {
      const updated = uploadeAssetMedia.filter(f => f.name !== assetName);
      dispatch(assetsActions.onChange("uploadeAssetMedia", updated));
    } else {
      toast.error("No assets to delete.");
    }
  };

  const truncate = name => {
    if (name?.length > 15) {
      return name.substring(0, 13) + "...";
    }
    return name || "";
  };

  const handleClose = () => {
    closePopup();
    dispatch(assetsActions.onChange("uploadeAssetMedia", []));
    setOpenGridViewOnUploadeAsset("");
    setSelectedFolder("");
  };

  return (
    <Dialog
      open={openPopup}
      classes={{ paper: classes.dialog }}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <div className={classes.paper}>
        <div className={classes.header}>
          <div className={classes.inenerContent}>
            <Typography className={classes.newPricingTypo}>
              Upload Assets
            </Typography>
          </div>
          <IconButton onClick={handleClose} className={classes.closIcon}>
            <AssetPopupClose width='24' height='24' />
          </IconButton>
        </div>

        <div
          className='uploadAssetsContanier'
          onDragOver={e => e.preventDefault()}>
          {currentRoot !== "/assets-media-document" ? (
            <div className='reciptPdf'>
              <Autocomplete
                disableClearable
                classes={{ paper: classes.papers }}
                popupIcon={<FiChevronDown />}
                value={selectedFolder || inputValue}
                onChange={(_, newValue) => {
                  onParentId(newValue?.id);
                  setInputValue(newValue);
                  setSelectedFolder(newValue);
                }}
                filterOptions={(options, params) => filter(options, params)}
                selectOnFocus
                clearOnBlur={false}
                handleHomeEndKeys
                options={reciptSelectedFolder}
                getOptionLabel={option => {
                  if (typeof option === "string") return option;
                  if (option.inputValue) return option.inputValue;
                  return option.name || "";
                }}
                renderOption={option =>
                  option.name === "View All" ? (
                    <div
                      style={{ width: "328px" }}
                      onClick={selectFolderDestination}>
                      <div className='viewFile'>{option.name || "--"}</div>
                    </div>
                  ) : (
                    <div>
                      <FolderIcon /> {option.name || "--"}
                    </div>
                  )
                }
                renderInput={params => (
                  <TextField
                    {...params}
                    placeholder={
                      selectedFolder ? selectedFolder.name : "Upload Location"
                    }
                    variant='outlined'
                  />
                )}
              />
            </div>
          ) : (
            <div className='reciptPdf' />
          )}

          <div className='uplodadfileRoot'>
            <input
              accept='application/pdf, image/jpeg, image/png, application/msword, video/mp4, .3gp, .docx, .doc'
              className={classes.fileInput}
              id='contained-button-file'
              type='file'
              // multiple
              onChange={uploadFileHandle}
            />
            <label htmlFor='contained-button-file'>
              <Button className='uploadFileBtn' component='span'>
                <UploadIcon width={64} height={64} />
              </Button>
            </label>
            <div className='dragContent'>
              Drag files here or click to upload
            </div>
          </div>

          <div className='mainSelectedContainer'>
            {uploadeAssetMedia?.map(f => (
              <div key={f.name} className='selectedAssests'>
                <span className='fileLink'>{truncate(f?.name)}</span>
                <span>
                  <IconButton
                    className={classes.deleteIcon}
                    onClick={() => handleDeleteFile(f?.name)}>
                    <Delete />
                  </IconButton>
                </span>
              </div>
            ))}
          </div>

          <div className={classes.submitBtnContainer}>
            <Button
              className={classes.uploadeAssetSubmitButton}
              variant='contained'
              color='primary'
              onClick={moveFilesIntoSelectedFolder}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default MediaUploadPopup;
